<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.visible"
    @before-close="handleBeforeClose"
    :center="true"
    width="680px"
    append-to-body
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :disabled="dialog.loading"
      label-width="240px"
    >
      <el-form-item label="资源组" prop="groupCode">
        <DynamicResource
          :singleSelect="'1'"
          v-model="form.groupCode"
        ></DynamicResource>
        <!-- <el-select v-model="form.groupCode" placeholder="请选择资源组" style="width:200px">
          <el-option v-for=" item in options.groupCode" :label="item.label" :value="item.value"
            :key="item.value"></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="命中渠道" prop="appid">
        <DynamicOption
          :singleSelect="'1'"
          v-model="form.appid"
          placeholder="请选择渠道"
        />
      </el-form-item>
      <el-form-item label="用户标签" prop="userTag">
        <el-select
          v-model="form.userTag"
          placeholder="请选择用户标签"
          style="width: 200px"
        >
          <el-option
            v-for="item in options.userTag"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户类型" prop="userType">
        <el-select
          v-model="form.userType"
          placeholder="请选择用户类型"
          style="width: 200px"
        >
          <el-option
            v-for="item in options.userType"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户id (uuid)" prop="uuid">
        <el-input
          v-model="form.uuid"
          placeholder="请输入用户 uuid"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item label="设备id (uid)" prop="uid">
        <el-input
          v-model="form.uid"
          placeholder="请输入设备 uid"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item label="应用版本" prop="cv">
        <el-input
          v-model="form.cv"
          placeholder="请输入应用版本, 正整数"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item label="SDK 版本号" prop="sdkCv">
        <el-input
          v-model="form.sdkCv"
          placeholder="如 60131-39505（原始格式，自动取 - 后段）"
          style="width: 200px"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" style="flex-end">
      <el-button size="mini" @click="hide">取 消</el-button>
      <el-button
        size="mini"
        type="primary"
        native-type="submit"
        :loading="dialog.loading"
        @click="handleQuery"
        >发起查询</el-button
      >
      <div style="margin-top: 24px">
        <el-input
          v-model="queryResult"
          type="textarea"
          :rows="6"
          :autosize="{ minRows: 6, maxRows: 6 }"
        ></el-input>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import DynamicOption from "@/components/DynamicOption/index.vue";
import DynamicResource from "@/components/DynamicOption/resource.vue";
import {
  getUserInfo,
  getHitConfig,
  getBigDataUserInfo,
} from "@/api/desk/notice";
// TODO: 字段名更换
const getDefaultForm = () => ({
  groupCode: "",
  appid: undefined,
  userTag: "",
  userType: "",
  uuid: "",
  uid: "",
  cv: "",
  sdkCv: "",
});
export default {
  name: "hit-query-dialog",
  components: {
    DynamicOption,
    DynamicResource,
  },
   created() {
    Promise.all[this.initUserTagOption(),this.initUserTypeOption()]
  },
  data() {
    return {
      queryResult: "",
      dialog: {
        loading: false,
        visible: false,
        title: "命中查询",
      },
      options: {
        // TODO: 下拉列表更换
        userTag: [],
        userType: [],
      },
      form: getDefaultForm(),
      rules: {
        groupCode: {
          required: true,
          message: "请选择资源组",
          trigger: ["blur", "change"],
        },
        appid: {
          required: true,
          message: "请选择渠道",
          trigger: ["blur", "change"],
        },
        // 应用版本, 正整数
        cv: {
          required: false,
          pattern: /^[1-9]\d*$/,
          message: "应用版本需为正整数",
          trigger: ["blur", "change"],
        },
      },
    };
  },

  methods: {
    async initUserTagOption(){
    const { data } = await getBigDataUserInfo();
    console.log("获取用户标签", data);
    this.options.userTag = data.data.map((item) => {
      return {
        label: item.tag,
        value: item.tag,
      };
    });
  },
   async initUserTypeOption(){
    const { data } = await getUserInfo();
    console.log("获取用户类型", data);
    this.options.userType = data.data.map((item) => {
      return {
        label: item.dictValue,
        value: item.dictKey,
      };
    });
   },
    show() {
      // 渠道默认值为空会有选中效果
      this.$set(this, "form", getDefaultForm());
      this.queryResult = "";

      this.dialog.visible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    hide() {
      this.dialog.visible = false;
    },
    handleQuery() {
      // TODO: 请求命中查询
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          /** 数据处理 */
          const params = { ...this.form };
          if (params.appid && Array.isArray(params.appid)) {
            params.appid = params.appid.join(",");
          }
          if (params.groupCode && Array.isArray(params.groupCode)) {
            params.groupCode = params.groupCode.join(",");
          }
          console.log("传递给接口的参数", params);
          const { data } = await getHitConfig(params);
          try {
            this.queryResult = JSON.stringify(data.data);
          } catch (error) {
            console.log("error", error);
          }
          console.log("命中查询接口的响应", data);
          // Promise.resolve(JSON.stringify(this.form)).then((res) => {
          //   this.queryResult = res

          //   // this.$emit('success')
          // }).finally(() => {
          //   this.loading = false;
          // })
        }
      });
    },
    handleBeforeClose(done) {
      if (!this.dialog.loading) {
        done();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
